import React, { useEffect } from "react";
import ColoredBorderSummaryCard from "../../../components/cards/ColoredBorderSummaryCard";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { fetchAllCouponsSummary } from "../../../redux/features/CouponSlice";

const CouponsSummary = () => {
  const { loading, couponsSummary } = useAppSelector((state) => state.coupons);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAllCouponsSummary());
  }, [dispatch]);


  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      <ColoredBorderSummaryCard
        title="Total Coupons"
        value={couponsSummary?.data?.totalCreated ?? 0}
        borderColor="border-t-purple-600"
        loading={loading}
        loadingColor="#9333EA"
      />
      <ColoredBorderSummaryCard
        title="Active Coupons"
        value={couponsSummary?.data?.totalActive ?? 0}
        borderColor="border-t-emerald-500"
        loading={loading}
        loadingColor="#10B981"
      />
      <ColoredBorderSummaryCard
        title="Used Coupons"
        value={couponsSummary?.data?.totalUsed ?? 0}
        borderColor="border-t-pink-500"
        loading={loading}
        loadingColor="#EC4899"
      />
      <ColoredBorderSummaryCard
        title="Expired Coupons"
        value={couponsSummary?.data?.totalExpired ?? 0}
        borderColor="border-t-red-500"
        loading={loading}
        loadingColor="#EF4444"
      />
    </div>
  );
};

export default CouponsSummary;
